if (!customElements.get('slider-default')) {
  class SliderDefault extends HTMLElement {
    constructor() {
      super();

      if (this.hasAttribute('data-disabled')) return;

      this.thumbs = this.querySelector('.js-thumbs');
      this.counterCurrent = this.querySelector('.js-counter-current');
      this.isTicker = this.classList.contains("js-slider-ticker");

      this.sliderOptions = {
        slidesPerView: 'auto',
        allowTouchMove: !this.hasAttribute('data-disable-mobile'),
        centeredSlides: this.hasAttribute('data-center-slides'),
        loop: this.hasAttribute('data-loop'),
        autoplay: (this.hasAttribute("data-autoplay")) ? { delay: (this.isTicker) ? 1 : parseInt(this.getAttribute("data-autoplay-speed")) } : false,
        speed: 6000,
        breakpoints: {
          750: {
            allowTouchMove: !this.hasAttribute('data-disable-desktop'),
            centeredSlides: this.hasAttribute('data-center-desktop'),
          },
        },
      };

      this.initSlider();
    }

    initSlider() {
      const pagination = this.querySelector('.js-pagination');
      const nextEl = this.querySelector('.js-next');
      const prevEl = this.querySelector('.js-prev');

      this.sliderOptions.pagination = {
        el: pagination,
        type: 'bullets',
        clickable: true,
      };

      this.sliderOptions.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
      };

      if (this.thumbs) {
        const thumbsSlider = this.querySelector('.js-thumbs-slider');
        const thumbsNext = this.querySelector('.js-thumbs-next');
        const thumbsPrev = this.querySelector('.js-thumbs-prev');

        this.thumbsSlider = new Swiper(thumbsSlider, {
          slidesPerView: 'auto',
          navigation: {
            nextEl: thumbsNext,
            prevEl: thumbsPrev,
          },
        });

        this.sliderOptions.thumbs = {
          swiper: this.thumbsSlider,
          autoScrollOffset: 1,
        };
      }

      if (this.hasAttribute('data-autoplay')) {
        this.sliderOptions.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }

      this.slider = new Swiper(
        this.querySelector('.js-slider'),
        this.sliderOptions,
      );

      if (!this.counterCurrent) return;

      this.slider.on('slideChange', () => {
        this.counterCurrent.textContent = this.slider.realIndex + 1;
      });
    }
  }

  customElements.define('slider-default', SliderDefault);
}
